import cn from 'classnames';
import React from 'react';

import s from './AuthFormWrapper.module.scss';

interface Props {
  children: JSX.Element[] | JSX.Element;
  withoutTopPadding?: boolean;
}

export default function AuthFormWrapper({
  children,
  withoutTopPadding,
}: Props): JSX.Element {
  return (
    <div
      className={cn(s.wrapper, {
        [s.withoutTopPadding]: withoutTopPadding,
      })}
    >
      {children}
    </div>
  );
}
